import { CurrencySEOMarkdown } from "../CurrencySEOMarkdown";

export default function HowToBuy({ currencyData }: any) {
  if (!currencyData?.whyToBuy) {
    return null;
  }
  return (
    <>
      <h2 className="h2">{currencyData?.howToBuy?.title}</h2>
      <CurrencySEOMarkdown className="description mt10">
        {currencyData?.howToBuy?.sub_title}
      </CurrencySEOMarkdown>
      <div className="separator"></div>
      <ul className="benifitsList">
        {currencyData?.howToBuy?.list?.map((item: any, index: number) => (
          <li key={index}>
            <CurrencySEOMarkdown>{item}</CurrencySEOMarkdown>
          </li>
        ))}
      </ul>
      <CurrencySEOMarkdown className="description">
        {currencyData?.howToBuy?.end_para}
      </CurrencySEOMarkdown>
    </>
  );
}
